import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';
import { kebabCase } from 'lodash';
import Icon from '../containers/icon';
const TriStateChecklistButton = _ref => {
  let isHovering = _ref.isHovering,
    onSelect = _ref.onSelect,
    onHover = _ref.onHover,
    item = _ref.item,
    disabled = _ref.disabled,
    _ref$item = _ref.item,
    id = _ref$item.id,
    status = _ref$item.status,
    name = _ref$item.name,
    title = _ref$item.title,
    glyph = _ref$item.glyph;
  const setItemHoverTrue = () => onHover(id, true);
  const setItemHoverFalse = () => onHover(id, false);
  const handleClick = () => onSelect(item, status);
  const glyphStyle = {
    marginRight: '5px',
    color: '#108368'
  };
  if (isHovering) {
    glyphStyle.color = '#ccc';
  }
  const className = "t-tscb-".concat(kebabCase(name));
  return /*#__PURE__*/React.createElement(Button, {
    title: title,
    onMouseEnter: setItemHoverTrue,
    onMouseLeave: setItemHoverFalse,
    onClick: handleClick,
    disabled: disabled,
    className: className
  }, /*#__PURE__*/React.createElement(Icon, {
    style: glyphStyle,
    glyph: glyph
  }), name);
};
TriStateChecklistButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  isHovering: PropTypes.bool.isRequired,
  item: PropTypes.shape({
    glyph: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    status: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
  onHover: PropTypes.func.isRequired
};
export default TriStateChecklistButton;